<template>
  <dialog-box
    v-model="$root.codeViewer.visible"
    :class="['code-viewer']"
    :full-screen="$root.codeViewer.fullScreen"
    :persistent="$root.codeViewer.persistent"
    :icon="$root.codeViewer.icon"
    :modal="$root.codeViewer.modal"
    :title="$root.codeViewer.title"
    :width="$root.codeViewer.width"
    :title-divider="false"
    :actions-divider="false"
    :min-width="$root.codeViewer.minWidth"
    :padding-off="$root.codeViewer.paddingOff"
    :title-bg-color="$root.colors.primary"
    :title-bg-color-lightness="$root.colors.bgColorLightness">
    <template v-slot:content>
      <tab
        name="code-dialog"
        color="white"
        :height="$root.codeViewer.tabHeight"
        :padding-off="$root.codeViewer.paddingOff"
        :dense="$root.codeViewer.tabDense"
        :bg-color="$root.colors.primary"
        :bg-color-lightness="$root.colors.bgColorLightness">
        <tab-panel v-for="(tab, index) in tabs" :key="index" :icon="tab.icon" :label="$lang[tab.key]">
          <vue-code-highlight :language="tab.language">{{ $root.codeViewer[tab.key] }}</vue-code-highlight>
        </tab-panel>
      </tab>
    </template>
    <template v-slot:actions>
      <btn
        @click="$root.codeViewer.visible = false"
        color="white"
        size="xs"
        :bg-color="$root.colors.primary"
        :bg-color-lightness="$root.colors.bgColorLightness"
        :title="$lang.close">{{ $lang.close }}</btn>
    </template>
  </dialog-box>
</template>
<script>
import { component as VueCodeHighlight } from 'vue-code-highlight'

export default {
  name: 'CodeViewer',
  components: {
    VueCodeHighlight
  },
  data () {
    return {
      tabs: [{
        language: 'html',
        icon: 'language-html5',
        key: 'template'
      }, {
        language: 'javascript',
        icon: 'language-javascript',
        key: 'script'
      }, {
        language: 'javascript',
        icon: 'database',
        key: 'data'
      }]
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/code-viewer.vue